import { Component, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FikoYTKokBilesenComponent } from '@service/kok-bilesen/kok-bilesen.component';

@Component({
  selector: 'hmi-pano-yetkisiz',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  templateUrl: './yetkisiz.component.html',
  styleUrl: './yetkisiz.component.less',
})
export class HmiPanoYetkisizComponent extends FikoYTKokBilesenComponent {
  constructor() { super(); }
}
